import { Vehicle } from './store/modules/charging-data.interface';

export const NAMESPACE = 'EQ_WCC';

export type VehicleDataSeamlessStoreState = {
  vehicleData?: Vehicle;
};
